import './src/styles/global.css';
import { scrollToHash } from './src/components/AnchorLink';

/**
 * Gatsby restores scroll position on navigation but does not resolve a hash in
 * the target URL, so cross-page anchor links are finished off here.
 */
export const onRouteUpdate = ({ location }) => {
  if (!location.hash) return;
  // Wait a frame so the destination page has painted before measuring offsets.
  window.requestAnimationFrame(() => scrollToHash(location.hash, 'auto'));
};
